const UsDeclarationsApiUrls = {
  GET: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/us-declarations/get`,
  POST: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/us-declarations/create`,
  PUT: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/us-declarations/update`,
  DELETE: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/us-declarations/delete`,
  EXPORT: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/us-declarations/download`
};

export default UsDeclarationsApiUrls
